import getUrlQueryParams from '../getUrlQueryParams';
import { getSelectedLocations } from '../index';

export default (state) => {
  const group = getUrlQueryParams()?.groupHighlight;

  const selectedLocations = getSelectedLocations(state);

  if (!group) return false;
  if (selectedLocations.length < 2) return false;

  if (state.fullListOfCountryGroups) {
    return state.fullListOfCountryGroups.find((el) => el.uid === group);
  }

  return false;
};
